<template>
  <div class="scensSetting_main"  :class="{'cn':version == '1'}">

    <div class="search_box">
      <div class="search">
        <el-input :placeholder="$t('App.text13')" @keyup.native="searchKeyUp($event)" v-model="keywords">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="search()"></i>
        </el-input>
      </div>
    </div>
    <div class="scensSetting_box">
      <div class="cont_ul_box">
        <div class="cont_ul scrollbar_style">
          <div class="sceneSettingBox"
            :key="item.id" v-for="(item, index) in sceneList" @click="itemFun((index + 1))" :class="{'select':(index + 1) == sceneIndex}" :style="{height:(index + 1) == sceneIndex ? (item.subHeight*8+7.36) + 'rem' : null}">
            <div class="title">
              <div class="el-icon-arrow-down"></div>
              <div class="text">{{ item.name ? item.name : '-' }}</div>
              <div class="box_2">
                <button class="apply" :class="item.status == 1 ? 'select' : ''" v-loading="item.sceneApplying" @click.stop="sceneApply(item)">{{$t('App.systemSetting.text25')}}</button>
                <!-- <div class="apply" @click.stop="clickStop()" @click="networking(scope.row)" @click="sceneApply(item)">  Apply</div> -->

                <div class="icon_box">
                  <!-- <img class="img" src="../img/point3.png" @click.stop="editShowFun($event,item)" /> -->
                  <div class="img" @click.stop="editShowFun($event,item)"></div>
                  <div class="bg" @click.stop="editShowFun($event,item)" :class="{ show: item.editShow }"></div>
                  <div class="popper_ul" :class="{ show: item.editShow, position: item.showPosition == 'top' }">
                    <div class="icon"></div>
                    <div class="ul">
                      <div class="popper_li" @click.stop="pageTypeFun('sceneSettingEdit', item)">
                        {{ $t('App.sceneSetting.btn1') }}</div>
                      <div class="popper_li" @click.stop="pageTypeFun('calendar', item)">{{ $t('App.sceneSetting.btn2') }}</div>
                      <div class="popper_li" @click.stop="del(item)">{{ $t('App.sceneSetting.btn3') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="body_paragraph_box" :style="{height:(index + 1) == sceneIndex ? (item.subHeight*8) + 'rem' : null}">
              <div class="body_paragraph" :key="obj.id" v-for="(obj,i) in item.subSceneList">
                <div class="paragraph">
                  <div style="margin-right: 1rem;">{{$t('App.systemSetting.text27')}}:</div>
                  <div class="text2_2">{{ obj.value ? obj.value : '0' }}%</div>
                </div>
                <div class="paragraph">
                  <div style="margin-right: 1rem;">{{$t('App.systemSetting.text28')}}:</div>
                  <div class="text2_2">{{ obj.controlArea ? obj.controlArea : '-' }}</div>
                </div>
                <div class="paragraph" v-if="item.scheduleList&&i==item.subSceneList.length-1">
                  <div style="margin-right: 1rem;">{{$t('App.systemSetting.text29')}}:</div>
                  <div class="text2_2">{{ item.scheduleList.length}}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="flex_box">
          <!-- <div class="el-icon-circle-plus-outline" @click="pageTypeFun('sceneSettingEdit')"></div> -->
          <div class="button" @click="isShowLogout = true">{{$t('App.systemSetting.text26')}}</div>
        </div>
      </div>
    </div>
    <!-- 确认添加 -->
    <div class="dialog_box" v-if="isShowLogout">
      <div class="bg"></div>
      <div class="form_box" >
        <div class="span">
          {{$t('App.text12')}}
        </div>
        <div class="btn_box">
          <div class="btn1" @click="isShowLogout = false">{{$t('App.no')}}</div>
          <div class="btn2" @click="pageTypeFun('sceneSettingEdit')">{{$t('App.yes')}}</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import allUrl from '../api/allUrl.js'
import base from '../api/base.js'

export default {
  name: "sceneSetting",
  data() {
    return {
      isShowLogout: false,
      isShowprojectCompleted: false,
      activeNames: ["1"],
      handleCommand: "",
      index: 1,
      editShow: false,
      editShow1: false,
      editShow2: false,
      editShow3: false,
      editShow4: false,
      editShow5: false,

      loading: {
        sceneApplying: false,
      },
      sceneIndex: null,
      sceneList: [],
      subSceneList: [],
      pageType: '',
      keywords: '',
    };
  },
  computed: {
    ...mapGetters({
      token: "token",
      client_key: "client_key",
      username: "username",
      version: "version",

      projectId: 'projectId',
      sceneId:'sceneId',

      remRatio: "remRatio",
      updateRemRatio: "updateRemRatio",

      countryId: "countryId",
      provinceId: "provinceId",
      cityId: "cityId",
      hotelId: "hotelId",
      headerIdStr: "headerIdStr",
      themeType: "themeType",
      // keywords: "keywords",
    }),
    // sensorFormModelName(){
    //     let name = '';
    //     for(let d of this.modelNav){
    //         if(d.id == this.sensorForm.model){
    //             name = d.name
    //         }
    //     }
    //     return name
    // }
  },
  components: {
    // 'sideBar':sideBar
  },
  beforeDestroy() { },
  mounted() {
    this.sceneListGet();
    
  },
  methods: {
    skinClassFun(){
      let obj = {};
      obj['cn'] = this.version == '1';
      // obj['ratio_1920_1080'] = this.ratio == '1';
      if(this.themeType == 1){
        obj['themeType_' + 1] = true;
      }
      // obj['themeType_' + 1] = true;
      return obj
    },
    handleChange(val) {
      console.log(val);
    },
    pageTypeFun(val, obj) {
      console.log(val)
      if (val == 'sceneSettingEdit') {
        this.$emit('pageTypeFun',val,obj)
      }
      if (val == 'calendar') {
        this.pageTitle = this.$t('App.pageTitle2')
        this.$emit('pageTypeFun',val, obj)
        console.log (obj,'--5---')
      }
      // this.pageType = val;

    },
   
    itemFun(index) {
      console.log(this.sceneIndex, index)
      if (this.sceneIndex == index) {
        this.sceneIndex = ''
      } else {
        this.sceneIndex = index;
      }
    },
    editShowFun(event,item) {
      console.log(event.clientY + 7.5*this.remRatio + 5.79*this.remRatio,$('.scensSetting_box').height()+$('.scensSetting_box').position().top,'96--95--')
      
      if(event.clientY + 7.5*this.remRatio + 8*this.remRatio>$('.scensSetting_box').height()+$('.scensSetting_box').position().top){
        item.showPosition = 'top'
      }else{
        item.showPosition = 'bottom'
      }
      item.editShow = item.editShow ? false : true;
    },
    edit() {
      this.$router.replace("edit_sceneSetting.vue");
    },
    del (item) {
      this.$confirm(
        this.$t('App.message.text3'), this.$t('App.message.text4'), {
        confirmButtonText: this.$t('App.message.text5'),
        cancelButtonText: this.$t('App.message.text6'),
        type: 'warning'
      }
      ).then(() => {
        console.log(item.id)
        base.ajax_post(
          allUrl.scene.scene_del,
          {
            username: this.username,
            clientType: this.os,
            token: this.token,
            id:item.id
          },
          {},
          data => {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'success'
            });
            this.sceneListGet();
          },
        this)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('App.message.text7')
        })
      });
    },
    // linkToFun(val,data){
    // }

    sceneApply(obj) {
      if (obj.sceneApplying) {
        return
      }
      let status = 0;
      if(obj.status == 1){
        status = 0;
      }else{
        status = 1;
      }
      obj.sceneApplying = true;
      base.ajax_post(
        allUrl.scene.scene_apply,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: obj.id,
          status:status,
        },
        {},
        data => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });

          obj.sceneApplying = false;
          this.sceneListGet();
        },
        this, () => {
          obj.sceneApplying = false;
        })
    },
    clickStop() {

    },
    searchKeyUp (e) {
      if (e.key == 'Enter') {
        this.search()
      }
    },
    search () {
      this.sceneListGet(1)
    },
    // 情景列表
    sceneListGet() {
      console.log(this.formReportQuestion)
      // baseApi.ajax_post(
      base.ajax_post(
        allUrl.scene.scene_list,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          clientType: this.os,
          keywords: this.keywords,
          projectId: this.projectId,
        },
        {},
        data => {
          let sceneList = []
          for (let d of data.data.list) {
            d.editShow = false
            d.sceneApplying = false
            d.subHeight = d.subSceneList.length;
            // console.log(d.subSceneList)
            sceneList.push(d)
          }
          this.$set(this,'sceneList',sceneList)
          // } else {
          //   this.$message({
          //     showClose: true,
          //     message: data.msg,
          //     type: 'success'
          //   });
          // }
        },
        this, () => { })
    },
  },
  watch: {
    projectId: function () {
      this.sceneListGet();
    },
  },

};
</script>

<style type="text/css" lang="less">
.scensSetting_main {
  position: absolute;
  z-index: 1;
  top: 7.37rem;
  left: 0;
  width: 100%;
  height: calc(100% - 7.37rem);
  min-height: 50rem;
  margin: 0 auto;
  overflow: hidden;
  // position: relative;
  display: flex;
  background: rgba(255, 255, 255, 0.85);
  justify-content: center;
  align-items: center;

  // .scensSetting_box {
  //   width: 115.09rem;
  //   height: 48.22rem;
  //   background: rgba(244, 251, 253, 0.9);
  //   display: block;
  // }
  .cont_ul {
    // height: 36.49rem;
    height: 38.82rem;


    .sceneSettingBox {
      height: 7.19rem;
      // width: 100%;
      // width: 115.09rem;

      // background: red;
      border-bottom: 0.1rem solid #3a636f;
      transition: all 0.5s;
      // display: flex;
      overflow: hidden;

      .title {
        display: flex;

        .el-icon-arrow-down {
          transition: all 0.5s;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          width: 2.37rem;
          height: 2.37rem;
          margin-left: 2.81rem;
          margin-top: 2.07rem;
          margin-right: 2.16rem;
          cursor: pointer;
        }

        .text {
          cursor: pointer;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          // line-height: 4.39rem;
          margin-top: 2rem;
          // background-color: #F4FBFD;
        }

        .box_2 {
          margin-left: auto;
          display: flex;
          align-items: center;
          height: 7.1rem;

          .apply {
            width: 10.35rem;
            height: 3.33rem;
            border: 1px solid #3a636f;
            border-radius: 0.44rem;
            background-color: rgba(244, 251, 253, 1);
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
            cursor: pointer;

            // margin-bottom: 1.75rem;
            // line-height: 4.39rem;
          }

          .img {
            // margin-top: 2.81rem;
            margin-left: 3.71rem;
            margin-right: 3.8rem;
            padding: 0 0.5rem;
            cursor: pointer;
          }

          .icon_box {
            position: relative;
            display: flex;
            align-items: center;
            width: 3rem;
            justify-content: center;

            .img {
              // margin-top: 2.81rem;
              // margin-left: 3.71rem;
              // margin-right: 3.8rem;
              height: 2rem;
              padding: 0 0.5rem;
              cursor: pointer;
            }

            .bg {
              position: fixed;
              top: 0;
              left: 0;
              top: 0;
              bottom: 0;
              right: 0;
              background: rgba(0, 0, 0, 0);
              z-index: 1;
              display: none;

              &.show {
                display: block;
              }
            }

            .popper_ul {
              // background: #fff;
              // width: 10.35rem;
              // height: 8.51rem;
              background: #f4fbfd;
              border: 1px solid #3a636f;
              border-radius: 0.44rem;

              display: none;
              position: absolute;
              top: 3rem;
              right: 0rem;
              z-index: 2;

              .ul {
                background: #F4FBFD;
                border-radius: 0.44rem;
                position: relative;
                z-index: 1;
                padding-top: 0.5rem;
              }

              .icon {
                position: absolute;
                right: 0.9rem;
                top: -0.5rem;
                width: 1rem;
                height: 1rem;
                background: #F4FBFD;
                border-top: 0.1rem solid #3A636F;
                border-left: 0.1rem solid #3A636F;
                // border-radius: 0.1rem;
                transform: rotateZ(45deg);
              }

              .popper_li {
                font-size: 1.8rem;
                font-family: Calibri;
                font-weight: normal;
                color: #3a636f;
                // margin-left: 1rem;
                // margin-right: 1rem;
                white-space: nowrap;
                margin: 0 1rem 0.5rem 1rem;
                cursor: pointer;
              }

              // .popper_li_1 {
              //   font-size: 1.83rem;
              //   font-family: Calibri;
              //   font-weight: normal;
              //   color: #3a636f;
              //   margin-left: 1.4rem;
              //   margin-top: 0.8rem;
              // }
              // font-size: 1.83rem;
              // font-family: Calibri;
              // font-weight: normal;
              // color: #3A636F;
              &.show {
                display: block;
              }
            }
          }
        }
      }

      &.select {
        height: 23.46rem;

        .el-icon-arrow-right {
          transform: rotate(90deg);
        }
      }
    }
  }
}

.ratio_1920_1080 {
  .scensSetting_main {
    position: absolute;
    top: 5.78rem;
    left: 0;
    width: 100%;
    height: calc(100% - 5.78rem);
    min-height: 50rem;
    margin: 0 auto;
    overflow: hidden;
    // position: relative;
    display: flex;
    background: rgba(255, 255, 255, 0.85);
    justify-content: center;
    align-items: center;
    .search_box{
      width: 86.32rem;
      position: absolute;
      top: 2rem;
      left: calc(50% - 43.16rem);
      display: flex;
      justify-content: flex-end;
    }
    .search {
      // position: absolute;
      // top: 0rem;
      // left: 0;

      .el-input__inner {
        border-radius: 0.33rem;
        border: 0.09px solid #3A636F;
        // height: 2.58rem;
        background: #f6f8fa;

        width: 27.11rem;
        height: 3.09rem;
        line-height: 3.09rem;

        font-family: Calibri;
        font-weight: 400;
        // font-size: 1.8rem;
      }
      .el-input {
        // width: 2.37rem;
        font-size: 1.8rem;
        line-height: 3.09rem;
      }
      .el-input__suffix{
        right: 2rem;
        .el-input__icon{
          line-height: 3.4rem;
        }
      }
    }
    .scensSetting_box {
      width: 86.32rem;
      // height: 100%;
      height: calc(100% - 15rem);

      // height: 38.68rem;
      // height: 48.22rem;

      // background: rgba(244, 251, 253, 0.9);
      // opacity: 0.9;
      display: block;
      // margin-top: 10rem;
    }
    .cont_ul_box{
      height: 100%;
      // display: flex;
      // align-items: center;
    }
    .cont_ul {
      // height: 27.37rem;
      height: calc(100% - 10rem);
      background: rgba(244, 251, 253, 0.9);

      .sceneSettingBox {
        height: 5.33rem;
        line-height: 5.36rem;
        // width: 100%;
        // width: 115.09rem;

        // background: red;
        border-bottom: 0.1rem solid #3a636f;
        transition: all 0.5s;
        // display: flex;
        overflow: initial;
        cursor: pointer;

        .title {
          display: flex;
          .el-icon-arrow-right {
            transition: all 0.5s;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
            width: 1.78rem;
            height: 1.78rem;
            margin-left: 1.97rem;
            margin-top: 2.07rem;
            margin-right: 1.64rem;
          }
          .text {
            // font-weight: normal;
            margin-top: 0.5rem;
            // background-color: #F4FBFD;
            font-family: Calibri;
            font-weight: normal;
            font-size: 1.8rem;
            color: #3A636F;
          }
          .box_2 {
            margin-left: auto;
            display: flex;
            align-items: center;
            height: 5.36rem;

            .apply {
              background-color: rgba(244, 251, 253, 1);
              cursor: pointer;
              width: 7.89rem;
              height: 2.96rem;
              border-radius: 0.33rem;
              border: 2px solid #3A636F;
              line-height: 0px;
              text-align: center;

              font-family: Calibri;
              font-weight: normal;
              font-size: 1.8rem;
              color: #3A636F;
              &.select {
                background-color: #00c6ff;
                border-color: #00c6ff;
                color: #fff;
              }
            }

            .img {
              background-image: url(../img/point3.png);

              width: 0.5rem;
              height: 1.8rem;
              background-position: center;
              background-repeat: no-repeat;
              background-size: 100% 100%;

              // margin-top: 2.81rem;
              padding: 0 ;
              // padding: 0 0.5rem;
              margin: 0;
              cursor: pointer;
            }

            .icon_box {
              position: relative;
              display: flex;
              align-items: center;
              width: 3rem;
              justify-content: center;
              margin-left: 3.71rem;
              margin-right: 3.8rem;

              // .img {
              //   // margin-top: 2.81rem;
              //   // height: 2.8rem;
              //   padding: 0 0;
              //   cursor: pointer;
              // }

              .bg {
                position: fixed;
                top: 0;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
                background: rgba(0, 0, 0, 0);
                z-index: 1;
                display: none;

                &.show {
                  display: block;
                }
              }

              .popper_ul {
                // background: #fff;
                // width: 10.35rem;
                // height: 8.51rem;
                background: #f4fbfd;
                border: 1px solid #3a636f;
                border-radius: 0.44rem;

                display: none;
                position: absolute;
                top: 2.5rem;
                right: 0rem;
                z-index: 2;
                &.position{
                  top: initial;
                  bottom: 3rem;
                  .icon {
                    top: initial;
                    bottom: -0.5rem;
                    border-top: none;
                    border-left: none;
                    border-bottom: 0.1rem solid #3a636f;
                    border-right: 0.1rem solid #3a636f;
                  }
                }

                .ul {
                  background: #F4FBFD;
                  border-radius: 0.44rem;
                  position: relative;
                  z-index: 1;
                  padding-top: 0.5rem;
                }

                .icon {
                  position: absolute;
                  right: 0.9rem;
                  top: -0.5rem;
                  width: 1rem;
                  height: 1rem;
                  background: #F4FBFD;
                  border-top: 0.1rem solid #3A636F;
                  border-left: 0.1rem solid #3A636F;
                  // border-radius: 0.1rem;
                  transform: rotateZ(45deg);
                }

                .popper_li {
                  line-height: 1.8rem;
                  font-size: 1.8rem;
                  font-family: Calibri;
                  font-weight: normal;
                  color: #3a636f;
                  // margin-left: 1rem;
                  // margin-right: 1rem;
                  white-space: nowrap;
                  margin: 0 1rem 0.5rem 1rem;
                  cursor: pointer;
                }

                // .popper_li_1 {
                //   font-size: 1.83rem;
                //   font-family: Calibri;
                //   font-weight: normal;
                //   color: #3a636f;
                //   margin-left: 1.4rem;
                //   margin-top: 0.8rem;
                // }
                // font-size: 1.83rem;
                // font-family: Calibri;
                // font-weight: normal;
                // color: #3A636F;
                &.show {
                  display: block;
                }
              }
            }
          }
        }

        &.select {
          height: 17rem;

          .el-icon-arrow-right {
            transform: rotate(90deg);
          }
        }
        .body_paragraph_box{
          overflow: hidden;
          height: 0;
          transition: all 0.5s;
        }
        .body_paragraph {
          margin-left: 5.46rem;
          line-height: 2.8rem;

          .paragraph {
            font-family: Calibri;
            font-weight: normal;
            font-size: 1.8rem;
            color: #3A636F;
            display: flex;

          }
        }
      }
    }

    .flex_box {
      display: flex;
      align-items: center;
      justify-content:flex-end;
      margin-right: 0.39rem;
      margin-top: 7.3rem;

      .button {
        width: 12.37rem;
        height: 3.16rem;
        line-height: 3.16rem;
        background: #00C6FF;
        border-radius: 0.2rem;
        text-align: center;
        font-family: Calibri;
        font-weight: 400;
        font-size: 1.8rem;
        color: #FFFFFF;
        cursor: pointer;
      }
    }

    .el-icon-circle-plus-outline {
      width: 4.28rem;
      height: 4.28rem;
      font-size: 1.8rem;
      color: #3a636f;
      cursor: pointer;
    }
    .dialog_box{
      position: fixed;
      top: 0;right: 0;left: 0;bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .bg{
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0);
        z-index: -1;
        opacity: 0.5;
      }
      .form_box{
        position: relative;
        width: 36.51rem;
        height: 18.09rem;
        padding-top: 5.79rem;
        background: #FFFFFF;
        border: 0px solid #3A636F;
        border-radius: 0.2rem;
        opacity: 0.9;
        .span{
          font-family: Calibri;
          color: #3A636F;
          text-align: center;
          // margin-bottom: 4.47rem;

          font-weight: 400;
          font-size: 1.8rem;
          color: #4C717C;
        }
        .btn_box{
          // position: absolute;
          // bottom: 0rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          // margin-top: 1.75rem;
          margin: 4.47rem auto 0;
          width: 26.69rem;
          .btn1{
            width: 6.25rem;
            height: 2.63rem;
            line-height: 2.63rem;
            border: 0.09rem solid #3A636F;
            text-align: center;
            
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
            cursor: pointer;
            user-select: none;

            background: #F2F2F2;
            border-radius: 0.2rem;
          }
          .btn2{

            width: 6.25rem;
            height: 2.63rem;
            background: #00C6FF;
            border-radius: 0.2rem;

            line-height: 2.63rem;
            border: 0.09rem solid #00C6FF;
            text-align: center;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #FFFFFF;
            cursor: pointer;
            user-select: none;
          }
        }
      }
    }
    
  }
}
// .scensSetting_main.themeType_1 {
//   background: rgba(250,  237, 218, 0.9);
    
//     .search {
//       .el-input__inner {
//         border: 0.09rem solid #682411;
//         background: rgb(255, 252, 249);
//         color: #682411;
//       }
//     }
//     .cont_ul {
//       background: rgb(255, 252, 249);
//       .sceneSettingBox {
//         border-bottom: 0.1rem solid #682411;
//         .title {
//           .el-icon-arrow-right {
//             color: #682411;
//           }
//           .text {
//             color: #682411;
//           }
//           .box_2 {
//             .apply {
//               background-color: rgb(255, 252, 249);
//               border: 2px solid #682411;
//               color: #682411;
//               &.select {
//                 // background-color: #00c6ff;
//                 // border-color: #00c6ff;
//                 color: #fff;
//                 background-color: #fdbe6e;
//                 border-color: #fdbe6e;
//               }
//             }
//             .img {
//               background-image: url(../img/orange/point3.png);
//               width: 1rem;
//               height: 2rem;
//               background-position: center;
//               background-repeat: no-repeat;
//               background-size: 100% 100%;

//               // margin-top: 2.81rem;
//               padding: 0 0.5rem;
//               margin: 0;
//               cursor: pointer;
//             }
//             .icon_box {

//               .img {
//                 background-image: url(../img/orange/point3.png);
//                 // width: 1rem;
//                 // height: 2rem;
//                 background-position: center;
//                 background-repeat: no-repeat;
//                 background-size: 100% 100%;
//                 padding: 0;

//                 height: 2.36rem;
//                 width: 0.5rem;
//                 padding: 0 ;
//               }
//               // .img {
//               //   // margin-top: 2.81rem;
//               //   height: 2rem;
//               //   padding: 0 0.5rem;
//               //   cursor: pointer;
//               // }
//               .popper_ul {
//                 background: #faedda;
//                 border: 1px solid #682411;
//                 &.position{
//                   .icon {
//                     border-bottom: 0.1rem solid #682411;
//                     border-right: 0.1rem solid #682411;
//                   }
//                 }
//                 .ul {
//                   background: #faedda;
//                 }
//                 .icon {
//                   background: #faedda;
//                   border-top: 0.1rem solid #682411;
//                   border-left: 0.1rem solid #682411;
//                 }
//                 .popper_li {
//                   color: #682411;
//                 }
//                 &.show {
//                   display: block;
//                 }
//               }
//             }
//           }
//         }
//         .body_paragraph {
//           .paragraph {
//             color: #682411;
//           }
//         }
//       }
//     }

//     .flex_box {
//       .button {
//         background: #f44336;
//         border: 0.09rem solid #f44336;
//         color: #ffffff;
//       }
//     }
//     .el-icon-circle-plus-outline {
//       color: #682411;
//     }
//     .dialog_box{
//       .form_box{
//         background: #FFFFFF;
//         border: 1px solid #682411;
//         opacity: 1;
//         .span{
//           color: #682411;
//         }
//         .btn_box{
//           .btn1{
//             background: #f2cd9b;
//             border: 0.1rem solid #682411;
//             color: #682411;
//           }
//           .btn2{
//             background: #f44336;
//             border: 0.09rem solid #f44336;
//             color: #ffffff;
//           }
//         }
//       }
//     }
// }
</style>